import React from "react";
import Layout from "../../Layout";
import PhoneInventoryContainer from "../../containers/PhoneInventory";
import { Helmet } from "react-helmet";

export default function PhoneInventoryPage() {
  return (
    <Layout>
      <Helmet>
        <title>Numbers Inventory - {process.env.REACT_APP_APP_NAME}</title>
      </Helmet>
      <PhoneInventoryContainer />
    </Layout>
  );
}
